import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithTeam } from '~/core/styleTypes';

import { centeredFlex } from '../../styles';

export const GOAL_HEIGHT = 88;
export const BACKGROUND_IMAGE_SIZE = 250;
export const LARGE_BACKGROUND_IMAGE_SIZE = 270;

export const GoalContainer = styled.div<WithTeam>`
    ${BaseStyle.Mixins.gaps.small}
    ${centeredFlex};
    height: ${GOAL_HEIGHT}px;
    overflow: hidden;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);

    background: ${({ $teamAbbrev, theme }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.gamecenter) || theme.Surface.Opposite.tertiary};
`;

export const GoalValue = styled.div<WithTeam & { $isScoringTeam: boolean }>`
    ${centeredFlex};
    ${BaseStyle.Mixins.fontStyles.ui['24b']}
    color: ${({ theme, $teamAbbrev }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.textOnGamecenter) || theme.Text.OppositeSurface.primary};
    max-width: 32px;
    opacity: ${({ $isScoringTeam }) => ($isScoringTeam ? 1 : 0.5)};
`;

export const GoalDescription = styled.div`
    ${centeredFlex};
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    color: ${({ theme }) => theme.Surface.primary};
    flex: 1;
    flex-direction: column;
    max-width: 108px;

    svg {
        fill: ${({ theme }) => theme.Utility.Opposite.critical};
    }
`;

export const GoalAndTeam = styled.div<WithTeam>`
    ${BaseStyle.Mixins.fontStyles.ui['14bCaps']}
    color: ${({ theme, $teamAbbrev }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.textOnGamecenter) || theme.Text.OppositeSurface.primary};
`;

export const GoalIconContainer = styled.div`
    ${centeredFlex};
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    border-radius: 100px;
    height: 40px;
    width: 40px;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
        z-index: 1;
        fill: ${({ theme }) => theme.Utility.critical};
    }
`;

export const GoalGlow = styled.div`
    position: absolute;
    width: 12px;
    height: 19px;
    background-color: rgba(233, 17, 17, 0.41);
    margin-top: 5px;
    border-radius: 30%;
    box-shadow: 0 -26px 112px 0 rgba(233, 17, 17, 0.74), 0 -11.553px 38.919px 0 rgba(233, 17, 17, 0.45),
        0 -6.172px 21.436px 0 rgba(233, 17, 17, 0.39), 0 -3.308px 13.374px 0 rgba(233, 17, 17, 0.37),
        0 -1.626px 8.363px 0 rgba(233, 17, 17, 0.35), 0 -0.609px 4.224px 0 rgba(233, 17, 17, 0.28);
`;

export const BackgroundTeam = styled.div<{ $isRight?: boolean }>`
    display: none;
    height: 0;
    width: 0;
    position: relative;
    top: -${BACKGROUND_IMAGE_SIZE / 2}px;

    img {
        opacity: 0.2;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        display: initial;
        left: ${({ $isRight }) => ($isRight ? 1 : -1) * (BACKGROUND_IMAGE_SIZE / 2)}px;

        img {
            height: ${BACKGROUND_IMAGE_SIZE}px;
            width: ${BACKGROUND_IMAGE_SIZE}px;
        }
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        left: ${({ $isRight }) => ($isRight ? 1 : -1) * (LARGE_BACKGROUND_IMAGE_SIZE / 2)}px;
        top: -${LARGE_BACKGROUND_IMAGE_SIZE / 2}px;

        img {
            height: ${LARGE_BACKGROUND_IMAGE_SIZE}px;
            width: ${LARGE_BACKGROUND_IMAGE_SIZE}px;
        }
    }
`;
